import { writable } from "svelte/store";
export const roleModules = writable([]);
